import { gql } from '@apollo/client';

export const GET_USER_CONTACT_INFO_GQL = gql`
  query GetUserContactInfo($userId: uuid!) {
    user(where: { id: { _eq: $userId } }) {
      name
      phone_number
      email
      push_notification_tokens(limit: 1, order_by: { updated_at: desc_nulls_last }) {
        phone_info
      }
    }
  }
`;

export const GET_USER_NOTIFICATION_TRANSPORT_SETTINGS_GQL = gql`
  query GetUserNotificationTransportSettings($userId: uuid!) {
    user_notification_transport_settings(where: { user_id: { _eq: $userId } }) {
      user_id
      sms
      push
      email
    }
  }
`;

export const UPSERT_USER_NOTIFICATION_TRANSPORT_SETTINGS_GQL = gql`
  mutation UpsertUserNotificationTransportSettings($user_id: uuid!, $sms: Boolean!, $push: Boolean!, $email: Boolean!) {
    insert_user_notification_transport_settings(
      objects: { user_id: $user_id, sms: $sms, push: $push, email: $email }
      on_conflict: { constraint: user_notification_transport_settings_pkey, update_columns: [sms, push, email] }
    ) {
      affected_rows
    }
  }
`;

export const GET_MOST_RECENT_NOTIFICATION_STATUSES_GQL = gql`
  query GetMostRecentNotificationStatuses($userId: uuid!, $phoneNumber: String!, $email: String!) {
    sms_statuses: message(
      where: {
        transported_as: { _eq: "sms" }
        user_id: { _eq: $userId }
        sent_to: { _eq: $phoneNumber }
        deleted_at: { _is_null: true }
      }
      limit: 1
      order_by: [{ sent_at: desc_nulls_last }, { created_at: desc_nulls_last }]
    ) {
      id
      sms_notification_statuses(
        where: { deleted_at: { _is_null: true } }
        limit: 20
        order_by: [{ occurred_at: desc_nulls_last }, { created_at: desc_nulls_last }]
      ) {
        id
        occurred_at
        status
      }
    }
    email_statuses: message(
      where: {
        transported_as: { _eq: "email" }
        user_id: { _eq: $userId }
        sent_to: { _eq: $email }
        deleted_at: { _is_null: true }
      }
      limit: 1
      order_by: [{ sent_at: desc_nulls_last }, { created_at: desc_nulls_last }]
    ) {
      id
      email_notification_statuses(
        limit: 20
        where: { deleted_at: { _is_null: true } }
        order_by: [{ occurred_at: desc_nulls_last }, { created_at: desc_nulls_last }]
      ) {
        id
        occurred_at
        status
      }
    }
    push_statuses: message(
      where: { transported_as: { _eq: "push" }, user_id: { _eq: $userId }, deleted_at: { _is_null: true } }
      limit: 1
      order_by: [{ sent_at: desc_nulls_last }, { created_at: desc_nulls_last }]
    ) {
      id
      push_notification_receipts(
        where: { deleted_at: { _is_null: true } }
        limit: 20
        order_by: [
          { receipt_checked_at: desc_nulls_last }
          { receipt_completed_at: desc_nulls_last }
          { updated_at: desc_nulls_last }
        ]
      ) {
        id
        occurred_at: receipt_checked_at
        status: receipt_status
        token {
          phone_info
        }
      }
    }
  }
`;

export const TEST_TRANSPORT_GQL = gql`
  mutation TestTransport($transportType: String!, $userId: String!) {
    user_notification_transport_type_test(
      transportType: $transportType
      userId: $userId
    ) {
      success
      messageId
      data
    }
  }
`;

export const SUBSCRIBE_EMAIL_NOTIFICATION_STATUS = gql`
  subscription SubscribeEmailNotificationStatus($messageId: uuid!) {
    email_notification_status(
      where: { message: { id: { _eq: $messageId } } }
      order_by: [{ occurred_at: desc_nulls_last }, { updated_at: desc_nulls_last }]
    ) {
      id
      occurred_at
      status
      message {
        id
        sent_to
        sent_at
      }
    }
  }
`;

export const SUBSCRIBE_SMS_NOTIFICATION_STATUS = gql`
  subscription SubscribeSmsNotificationStatus($messageId: uuid!) {
    sms_notification_status(
      where: { message: { id: { _eq: $messageId } } }
      order_by: [{ occurred_at: desc_nulls_last }, { updated_at: desc_nulls_last }]
    ) {
      id
      occurred_at
      status
      message {
        id
        sent_to
        sent_at
      }
    }
  }
`;

export const SUBSCRIBE_PUSH_NOTIFICATION_STATUS = gql`
  subscription SubscribePushNotificationStatus($messageId: uuid!) {
    push_notification_receipt(
      where: { message: { id: { _eq: $messageId } } }
      order_by: [
        { receipt_checked_at: desc_nulls_last }
        { receipt_completed_at: desc_nulls_last }
        { created_at: desc }
      ]
    ) {
      id
      occurred_at: receipt_completed_at
      status: receipt_status
      message {
        id
        sent_to
        sent_at
      }
      token {
        phone_info
      }
    }
  }
`;
